//@flow
import React from 'react';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';

import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type ProductModel from '../../Stores/Products/productModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';

type Props = {
  product:ProductModel,
  quote:QuoteModel,
  lessText?:boolean,
  strikeUnselectedPrice?:boolean,
  hideMemInfo?:boolean,
  membershipPlan:MembershipPlanModel,
  isOffice?:boolean,
};

export default function MsrpProductPrices(props:Props) {
  const customerGroup = props.quote.getCustomerGroup();
  const msrpPrice = props.product && Number(props.product.getMsrp());
  const customerPrice = props.product && Number(props.product.getCustomerGroupPrice(customerGroup));
  const showMsrp = ((msrpPrice - customerPrice) > 0) &&
    !props.membershipPlan.hideMembershipInfo();

  return (
    <div className="prices-container group">
      {showMsrp && _getMsrpPrice(props, msrpPrice)}
      <div className={_getMemberClass(props, showMsrp)}>
        <span>${customerPrice }</span>
        {showMsrp && _getText(props)}
        {_getInfoIcon(props)}
      </div>
    </div>
  );
}

function _openModal() {
  ModalActions.openModal(Constants.MSRP_POP_MODAL);
}

function _getInfoIcon(props:Props) {
  if (props.hideMemInfo || props.lessText || props.membershipPlan.hideMembershipInfo()) return;
  return (
    <span className="info-icon" onClick={_openModal} />
  );
}

function _getMsrpPrice(props:Props, msrpPrice:number) {
  return (
    <div className={_getMsrpClass(props)}>
      ${msrpPrice.toFixed(2)}
    </div>
  );
}

function _getText(props:Props) {
  if (props.lessText) return;
  const copy = props.isOffice
    ? 'with SnackPass'
    : 'with member discount';
  return (
    <span className="member-discount"> {copy}</span>
  );
}

function _getMsrpClass(props:Props) {
  let className = 'msrp-price';
  if (!props.quote.isMsrp() && props.strikeUnselectedPrice) {
    className += ' unselected';
  }
  return className;
}

function _getMemberClass(props:Props, showMsrp:boolean) {
  let className = 'member-price';
  //only strike out the membership price if there is also an MSRP price
  if (props.quote.isMsrp() && props.strikeUnselectedPrice && showMsrp) {
    className += ' unselected';
  }
  return className;
}
